<template>
    <edit-drawer :title="$t('edit.ruler.editRuler')" :is-back="true" @goBack="clickBack">
        <template>
            <!--標題-->
            <title-edit :data="rulerObj" @isShowTitle="isShowTitle" @titleChange="titleChange" :title="$t('edit.ruler.name')"></title-edit>
            <div class="cut-line"><!--分割線--></div>
            <!-- 長度 -->
            <div class="link-text">
                <div class="titles">
                    <span>{{$t('edit.ruler.long')}}</span>
                </div>
                <a-input :placeholder="$t('edit.ruler.longInput')" v-model="rulerObj.length" type="number" @change="changeLength"/>
            </div>
            <div class="cut-line"><!--分割線--></div>
            <!-- 長度 -->
            <div class="link-text">
                <div class="titles">
                    <span>{{$t('edit.ruler.unit')}}</span>
                </div>
                <a-select
                        style="width: 100%"
                        :default-value="rulerObj.unit"
                        @change="handleChange"
                        dropdownClassName="edit-select"
                >
                    <a-select-option v-for="(item,index) in unitList" :key="index" :value="item">{{item}}</a-select-option>
                </a-select>
            </div>
        </template>
        <template #bottom>
            <double-btn @onClickSave="onClickSave" @onClickCancel="clickBack"></double-btn>
        </template>
    </edit-drawer>
</template>

<script>
    import EditDrawer from "../EditDrawer";
    import DoubleBtn from "../DoubbleBtn";
    import TitleEdit from "../hotpoint/TitleEdit";
    import { v4 as uuidv4 } from "uuid";
    export default {
        name: "rulerSetting",
        props:{
            targetObj:{
                type:Object,
                default: ()=>{}
            }
        },
        components:{
            EditDrawer,
            DoubleBtn,
            TitleEdit
        },
        data(){
            return{
                rulerObj:{
                    title: '',
                    is_show_title: 1,
                    length: 0,
                    unit: this.$t('edit.ruler.meter'),
                    ruler_id:'',
                    hotspot_mark:{
                        name:"ruler_" + uuidv4(),
                        point:[]
                    },
                    hotspot_desc:{
                        ath:0,
                        atv:0,
                        txt:this.$t('edit.ruler.dragAdjustPosition')
                    }
                },
                kr:null,
                isNewRuler: true,
                unitList:[
                    this.$t('edit.ruler.meter'),
                    this.$t('edit.ruler.centimeter'),
                    this.$t('edit.ruler.kilometre'),
                    this.$t('edit.ruler.millimeter'),
                    this.$t('edit.ruler.size'),
                    this.$t('edit.ruler.m'),
                    this.$t('edit.ruler.cm'),
                    this.$t('edit.ruler.km'),
                    this.$t('edit.ruler.mm'),

                ],
            }
        },
        watch: {
            targetObj: {
                handler: function (value) {
                    if (value) {
                        this.rulerObj = value;
                        this.isNewRuler = false;
                    }
                },
                immediate: true,
                deep: true,
            },
            'rulerObj.is_show_title'(newVal){
                if(newVal == 1){
                    this.updateTxt(true)
                }else{
                    this.updateTxt(false)
                }
            }
        },
        created() {
            this.kr = document.getElementById('krpanoSWFObject');
            //初始化標尺
            this.initRuler()
            //判斷是否是新增，是的話，存緩存
            if(this.isNewRuler){
                let data = {
                    type: 'ruler',
                    item: this.rulerObj
                }
                sessionStorage.setItem('addItem',JSON.stringify(data))
            }
        },
        methods:{
            //初始化標尺
            initRuler(){
                const mark = {...this.rulerObj.hotspot_mark};
                const desc = {...this.rulerObj.hotspot_desc};
                if(!this.isNewRuler){
                    this.deleteInitRuler()
                }
                krMarkLine.init(this.kr,true,mark,desc);
            },
            //刪除當前標尺
            deleteInitRuler(){
                krMarkLine.krpano_obj = this.kr;
                krMarkLine.hotspot_mark.name = this.rulerObj.hotspot_mark.name
                krMarkLine.delete()
            },
            //返回或取消
            clickBack() {
                this.deleteInitRuler()
                if(!this.isNewRuler){
                    const mark = {...this.rulerObj.hotspot_mark};
                    const desc = {...this.rulerObj.hotspot_desc};
                    krMarkLine.init(this.kr,false,mark,desc);
                }else{
                    sessionStorage.removeItem("addItem");
                }
                this.$emit("clickBack");
            },
            //保存
            onClickSave() {
                if(this.rulerObj.title == ''){
                    this.$message.error(this.$t("edit.ruler.pleaseFillTitle"))
                    return
                }
                let list = krMarkLine.returnData()
                this.rulerObj = {...this.rulerObj,...list}
                this.$set(this.rulerObj,'ruler_id',this.rulerObj.hotspot_mark.name)
                this.$emit("saveChangeData",
                    {
                        key: this.rulerObj.hotspot_mark.name,
                        data: this.rulerObj,
                    });
            },
            //是否顯示名字
            isShowTitle(value) {
                this.rulerObj.is_show_title = value ? 1 : 0;
            },
            //名稱改變
            titleChange(value) {
                this.rulerObj.title = value;
                if(this.rulerObj.is_show_title == 1){
                    this.updateTxt(true)
                }
            },
            //長度改變
            changeLength(e){
                this.rulerObj.length = parseFloat(e.target.value)
                this.updateTxt(true)
            },
            //單位修改
            handleChange(e){
                this.rulerObj.unit = e
                this.updateTxt(true)
            },
            //修改文字內容
            updateTxt(showTitle){
                if(showTitle){
                    krMarkLine.hotspot_desc.txt = this.rulerObj.title + this.rulerObj.length + this.rulerObj.unit
                }else{
                    krMarkLine.hotspot_desc.txt = this.rulerObj.length + this.rulerObj.unit
                }
                krMarkLine.addTxt()
            },
        }
    }
</script>

<style lang="less" scoped>
    .link-text{
        margin: 20px 16px;
        .titles{
            display: flex;justify-content: space-between;margin: 10px 0;
        }
    }
</style>
